import en from '../locales/en';
import fr from '../locales/fr';

const setLangText = lang => {
  return lang === 'en' ? en : fr;
};

export default setLangText;
